var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import triggerAnalyticsEvent, { Analytics } from '../../../helpers/analyticsMiddleware';
import i18n, { t } from '../../../strings/i18n/i18n';
import { ModalFooter, ModalHeader, SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../redux/ui/ui.slice';
import { H5 } from 'syf-component-library/ui/typography';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { ModalType } from '../../../redux/ui/typings';
import DisputesImage from '../../../ui/atoms/DisputesImage';
import SLIDE_IN_MODAL_CONTAINER_ID from '../../../const/modalContainerIds';
import { Trans } from 'react-i18next';
import OnlineChatLink from '../../../ui/atoms/OnlineChatLink';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import LaunchPointName from '../../../const/launchPointName';
var ImageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", "px auto;\n"], ["\n  margin: ", "px auto;\n"])), spacing.large);
var Title = styled(H5)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 auto;\n  text-align: center;\n  font-weight: ", ";\n  width: 80%;\n\n  @media ", " {\n    font-size: ", "px;\n    width: 100%;\n  }\n"], ["\n  margin: 0 auto;\n  text-align: center;\n  font-weight: ", ";\n  width: 80%;\n\n  @media ", " {\n    font-size: ", "px;\n    width: 100%;\n  }\n"])), fontWeights.bold, query.lessThanMedium, fontSizes.root);
var CustomModalFooter = styled(ModalFooter)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media ", " {\n    min-height: 96px;\n  }\n"], ["\n  @media ", " {\n    min-height: 96px;\n  }\n"])), query.lessThanMedium);
export var getPageAnalytics = function (isRedispute, error) {
    if (isRedispute) {
        return {
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Redispute,
            pageName: Analytics.Error,
            errorMessage: error.message
        };
    }
    return {
        pageKind: Analytics.Dispute,
        pageFunction: Analytics.Status,
        pageName: Analytics.ServerError,
        errorMessage: error.message
    };
};
var DisputesWrapperError = function (_a) {
    var modalType = _a.modalType, error = _a.error;
    var dispatch = useDispatch();
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var _b = useSelector(function (state) { return state; }, shallowEqual), assetsURL = _b.mfeConfig.assetsURL, accountId = _b.appConfig.accountId, isRedispute = _b.questionnaire.isRedispute;
    var handleCloseModal = function () {
        dispatch(closeModal());
    };
    var handleLaunchChat = function () {
        pointOfNeedChat(LaunchPointName.Disputes, accountId);
    };
    useEffect(function () {
        if (modalType === ModalType.DisputeInfo) {
            var pageAnalytics = getPageAnalytics(isRedispute, error);
            triggerAnalyticsEvent(pageAnalytics);
        }
    }, [modalType, error, isRedispute]);
    return (_jsxs(SlideInModalPortal, __assign({ id: "modal", containerId: SLIDE_IN_MODAL_CONTAINER_ID, isOpen: true, escapeModalHandler: handleCloseModal, header: _jsx(ModalHeader, { content: t('eligibility.disputeDetails'), closeModal: handleCloseModal, dataType: isRedispute && Analytics.Redispute, dataReason: "x button" }), footer: _jsx(CustomModalFooter, { handlePrimaryButton: handleCloseModal, primaryText: t('button.close'), dataType: isRedispute && Analytics.Redispute, dataPrimaryReason: "Close" }) }, { children: [_jsx(ImageWrapper, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "API_ERROR", size: "small" }) }), _jsx(Title, { children: t('allDisputes.disputeError') }), _jsx(Title, { children: _jsx(Trans, { i18n: i18n, i18nKey: "allDisputes.pleaseTryAgain", components: [
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": Analytics.OnlineChat, "data-title": "transaction-enrichment", "data-type": "transaction-enrichment", onClick: handleLaunchChat }, "online chat")
                    ] }) })] })));
};
export default DisputesWrapperError;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map